// extracted by mini-css-extract-plugin
export default {"baseButton":"NativeModuleTimePicker_baseButton__nAJkJ","chooserButton":"NativeModuleTimePicker_chooserButton__BCNDF"};